import log from 'Utilities/log';
const handleMessage = (event, resolve, cleanup) => {
  try {
    const data = JSON.parse(event.data);
    if (data.type === 'AUTH_TOKEN' && data.token) {
      cleanup();
      resolve(data.token);
    }
  } catch {
    // Expected during initial render - token not yet sent
    log.info('Waiting for token...');
  }
};
export const waitForToken = queryToken => {
  return new Promise((resolve, reject) => {
    if (queryToken) {
      resolve(queryToken);
      return;
    }
    const browserListener = event => handleMessage(event, resolve, cleanup);
    const rnListener = event => handleMessage(event, resolve, cleanup);
    window.addEventListener('message', browserListener);
    document.addEventListener('message', rnListener);
    const cleanup = () => {
      window.removeEventListener('message', browserListener);
      document.removeEventListener('message', rnListener);
      clearTimeout(timeoutId);
    };
    const timeoutId = setTimeout(() => {
      cleanup();
      reject({
        status: 401,
        message: 'Token timeout'
      });
    }, 20000);
  });
};